import { chainValidations, makeFormStateWithModel } from 'formtastisch'
import { type IntlShape } from 'react-intl'

import { validateEmail, validateRequired } from '../base-form-handling'

export const makeLoginRegistrationUserLoginFormState = (
  intl: IntlShape,
  username: string,
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types -- the rule was disabled before a comment became required
) => {
  return makeFormStateWithModel({
    initialData: {
      fcSolution: '',
      password: '',
      username,
    },
    validations: {
      password: (value: string) => {
        return validateRequired(
          value,
          intl.formatMessage({ id: 'form.error.input.missing' }),
        )
      },
      username: (value: string) => {
        return chainValidations(
          () =>
            validateRequired(
              value,
              intl.formatMessage({ id: 'form.error.input.missing' }),
            ),
          () =>
            validateEmail(
              value,
              intl.formatMessage({ id: 'error.email.invalid' }),
            ),
        )
      },
    },
  })
}

export type LoginRegistrationUserLoginFormState = ReturnType<
  typeof makeLoginRegistrationUserLoginFormState
>
